import { EnvironmentProviders, inject, provideEnvironmentInitializer, Provider } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import {
  MAT_DIALOG_DEFAULT_OPTIONS,
  MAT_DIALOG_SCROLL_STRATEGY,
  MatDialog,
  MatDialogConfig,
} from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { filter } from 'rxjs';

const DIALOG_CONFIG: MatDialogConfig = {
  autoFocus: false,
  hasBackdrop: true,
  minWidth: '637px',
  maxHeight: '80vh',
};

export function provideDialogs(): (Provider | EnvironmentProviders)[] {
  return [
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: DIALOG_CONFIG },
    {
      provide: MAT_DIALOG_SCROLL_STRATEGY,
      useFactory: (overlay: Overlay) => () => overlay.scrollStrategies.noop(),
      deps: [Overlay],
    },
    // `closeOnNavigation` only reacts to popstate/hashchange, so RouterLink (pushState) navigation leaves dialogs open.
    provideEnvironmentInitializer(() => {
      const dialog = inject(MatDialog);

      inject(Router)
        .events.pipe(filter((event) => event instanceof NavigationStart))
        .subscribe(() => dialog.closeAll());
    }),
  ];
}
